export default __webpack_public_path__ + "static/media/logo.22720c99.jpg";